import React, { type ComponentProps } from 'react';
import * as Tooltip from '@periodica/ui-kit/tooltip';
import { BaseContainer } from '@periodica/ui-kit';
import {
  SquaresFour as ProjectsIcon,
  ShoppingCard as CartIcon,
  Profile as ProfileIcon,
} from '@periodica/ui-kit/icons';

import type { StrapiHeaderNavItem } from '@customTypes/strapiData';
import { Menu } from '../Menu';
import { Logo } from '../Logo';
import * as styles from './index.module.css';

type DesktopHeader = {
  items: StrapiHeaderNavItem[];
};

type IconButtonArgs = {
  title: string;
  url: string;
  Icon: ({ ...args }: ComponentProps<typeof ProjectsIcon>) => JSX.Element;
};

function IconButton({ title, url, Icon }: IconButtonArgs) {
  return (
    <Tooltip.Provider placement="bottom">
      <Tooltip.Anchor
        render={
          <a
            href={`${process.env.GATSBY_CONSTRUCTOR_URL}/${url}`}
            className={styles.icon}
            target="_blank"
            rel="noreferrer"
          >
            <Icon />
          </a>
        }
      />
      <Tooltip.Tooltip gutter={8}>{title}</Tooltip.Tooltip>
    </Tooltip.Provider>
  );
}

export function DesktopHeader({ items }: DesktopHeader) {
  return (
    <div className={styles.wrapper}>
      <BaseContainer className={styles.container}>
        <Logo />
        <div className={styles.menuContainer}>
          <div className={styles.menuContent}>
            <Menu items={items} />
          </div>
        </div>
        <div className={styles.icons}>
          <IconButton title="Проекты" url="projects" Icon={ProjectsIcon} />
          <IconButton title="Корзина" url="cart" Icon={CartIcon} />
          <IconButton title="Аккаунт" url="account" Icon={ProfileIcon} />
        </div>
      </BaseContainer>
    </div>
  );
}
